// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__JY0Q+","spinner":"Loader_spinner__vz8fQ"};